import { RateApp } from 'capacitor-rate-app'
import { persisted } from 'svelte-local-storage-store'
import { get } from 'svelte/store'
import { Capacitor } from '@capacitor/core'

const threeWeeks = 1000 * 60 * 60 * 24 * 21

const OPEN_LIMIT = 15
const TIME_LIMIT = threeWeeks

const reviewPromptData = persisted("reviewPromptData", {
    opened: 0,
    start: Date.now()
})

/**
 * Increment every time the module is loaded,
 * once per session
 */
reviewPromptData.update(data => {
    data.opened = data.opened + 1
    return data
})

export function reviewPromptIfReady() {
    const data = get(reviewPromptData)
    const now = Date.now()

    if (!Capacitor.isNativePlatform()) return
    if (now < TIME_LIMIT + data.start) return
    if (data.opened < OPEN_LIMIT) return

    RateApp.requestReview()

    // Reset
    reviewPromptData.set({
        opened: 0,
        start: Date.now()
    })
}

